import {fetchJson} from "./fetch";

export interface geoInfo {
    ip_address: string;
    ip_version: string;
    continent: string;
    country: string;
    region: string;
    city: string;
    colo: string;
    asn: number;
}

export const get = async (): Promise<{ status: number, data: geoInfo }> => {
    return await fetchJson<geoInfo>("https://ipv4-check-perf.radar.cloudflare.com/api/info")
}